"use client";
import {ReactNode} from "react";
import {OnboardContextProvider} from "@/app/(onboard)/OnboardContext";
import SideImage from "@/component/blocks/onboard-blocks/SideImage";
import OnboardStep from "@/component/blocks/onboard-blocks/OnboardStep";
import clsx from "clsx";

const OnboardLayout = ({children}: {children: ReactNode}) => {
    return (
        <OnboardContextProvider>
            <div className="flex flex-row h-screen overflow-hidden">

                {/* SideImage */}
                <div className={clsx(
                    "absolute inset-0",
                    "sm:relative sm:inset-auto sm:top-0",
                    "sm:h-screen sm:w-[320px]",
                    "lg:w-120 xl:w-140",
                    "shrink-0"
                )}><SideImage/></div>

                {/* Right panel — THIS is the scroll container */}
                <div className={clsx(
                    "relative z-10 flex-1 flex flex-col bg-white m-auto",
                    "overflow-y-auto overflow-x-hidden",
                    "mx-4 my-4 p-4 pt-0 bg-darkgray/50 backdrop-blur-sm rounded-lg",
                    "sm:bg-white sm:backdrop-blur-none sm:px-6",
                    "[&::-webkit-scrollbar]:w-0"
                )}>
                    <div className={clsx(
                        "sticky top-0 z-20 flex justify-center m-auto mb-0 pb-4",
                        "bg-white/80 backdrop-blur-md",
                        "sm:bg-white/80 sm:backdrop-blur-md"
                    )}><OnboardStep/></div>

                    {/* Children */}
                    <div className=" mt-10 flex-col justify-center w-full max-w-101 m-auto">
                        {children}
                    </div>
                </div>

            </div>
        </OnboardContextProvider>
    )
}
export default OnboardLayout;